import React, { useEffect, useState } from 'react';
import { Formik } from 'formik';
import { useParams } from 'react-router-dom';
import SweetAlert from 'react-bootstrap-sweetalert';
import { Container, Button, Col, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { get } from 'lodash';
import validationSchema from '../form/SiteCreatorForm.schema';
import SiteCreatorForm from '../form/SiteCreatorForm';
import CommonLoader from '../../common/components/CommonLoader';
import PageBreadcrumb from '../../common/components/layout/PageBreadcrumb';
import { getSite, editSite, deleteSite } from '../SiteCreatorActions';

const initialValues = {
  title: '',
  link: '',
  isActive: false,
  content: '',
};

function EditSitePage() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [showAlert, setShowAlert] = useState(false);
  const [site, setSite] = useState(initialValues);
  const data = useSelector((state) => state.siteCreator.get('siteDetails'));
  const loaderStatus = useSelector((state) => state.siteCreator.get('loaderStatus'));

  useEffect(() => {
    setSite({
      title: data?.title,
      link: data?.link,
      content: data?.content,
      isActive: data?.isActive,
    });
  }, [data]);

  useEffect(() => {
    dispatch(getSite(id));
  }, [dispatch, id]);

  const handleSubmit = (values, form) => {
    dispatch(editSite(id, get(data, 'version'), values, form)).catch(() =>
      form.setSubmitting(false),
    );
  };

  const handleDeleteSite = () => {
    dispatch(deleteSite(id));
  };

  const breadcrumbs = [
    { id: 1, type: 'home' },
    { id: 2, type: 'link', text: 'Site Creator', url: '/site-creators' },
    { id: 3, type: 'span', text: 'Edit Site' },
  ];

  return (
    <Container fluid>
      <PageBreadcrumb items={breadcrumbs} pageTitle="Site Creator" />
      <Row className="delete-button-wrapper">
        {data?.isCustomSite && (
          <Col xs="12">
            <Button
              className="float-end mb-3 rounded-pill btn-danger"
              onClick={() => setShowAlert(true)}
            >
              Delete Site
            </Button>
          </Col>
        )}
      </Row>
      <CommonLoader status={loaderStatus}>
        <Formik
          initialValues={site}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          validateOnBlur
          enableReinitialize
        >
          {() => <SiteCreatorForm title="Edit Site" isCustom={data?.isCustomSite} />}
        </Formik>
      </CommonLoader>
      <SweetAlert
        danger
        showCancel={false}
        showConfirm={false}
        show={showAlert}
        title="Warning!"
        onConfirm={() => {
          setShowAlert(false);
          handleDeleteSite();
        }}
        onCancel={() => setShowAlert(false)}
      >
        {(renderProps) => (
          <div>
            <p>Are you sure to remove a site?</p>
            <div className="d-flex justify-content-center gap-2 mt-3">
              <Button className="rounded-pill btn-soft-primary" onClick={renderProps.cancel}>
                Cancel
              </Button>
              <Button className="rounded-pill btn-primary" onClick={renderProps.confirm}>
                Yes, Delete
              </Button>
            </div>
          </div>
        )}
      </SweetAlert>
    </Container>
  );
}

export default EditSitePage;
